import { cn } from '@/lib/utils';

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {}

/**
 * A skeleton loading placeholder that displays an animated pulse effect.
 * Used to reserve space and indicate loading state without causing layout shift.
 */
export function Skeleton({ className, ...props }: SkeletonProps) {
  return (
    <div
      className={cn('bg-muted/50 rounded animate-pulse', className)}
      {...props}
    />
  );
}
